import { render, staticRenderFns } from "./InstructionsEdit.vue?vue&type=template&id=fd211f56&"
import script from "./InstructionsEdit.vue?vue&type=script&lang=js&"
export * from "./InstructionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports